/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable prefer-const */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useRef } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import ContainerFlex from '../containerFlex';
import * as St from './styles';
import Input from '../newInput';
import Checkbox from '../checkbox';
import Button from '../button';

export interface IOption {
  readonly id?: string | number;
  value: string;
}

export type InputProps = {
  name?: string;
  id?: string;
  label?: string;
  disabled?: boolean;
  errorMessage?: string;
  options?: IOption[];
  value?: IOption[];
  onChange?: (option: IOption[]) => void;
  onFocus?: (isOpen: boolean) => void;
  readOnly?: boolean;
  heightWhenOpen?: string;
  continerOptionsStyle?: React.CSSProperties;
  limitTag?: number;
  showChips?: boolean;
  closeWhenSelect?: boolean;
  btnClear?: boolean;
};

const FreeSelectMultiple = ({
  label,
  value,
  errorMessage,
  onChange,
  readOnly,
  options = [],
  disabled,
  heightWhenOpen,
  continerOptionsStyle,
  limitTag = 3,
  onFocus,
  name,
  showChips = true,
  closeWhenSelect = false,
  btnClear = true,
}: InputProps): JSX.Element => {
  const [isFocused, setIsFocused] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState<IOption[]>(() => value ?? []);
  const [filterText, setFilterText] = useState('');
  const anchorRef = useRef(null);

  useEffect(() => {
    setSelectedOptions(value ?? []);
  }, [value]);

  useEffect(() => {
    if (onFocus) {
      onFocus(isFocused);
    }
  }, [isFocused]);

  const handleToggleFocus = (e) => {
    e.stopPropagation();
    if (!readOnly) setIsFocused((prev) => !prev);
  };

  const inputValue = selectedOptions
    .slice(0, limitTag)
    .map((e) => e.value.split(' ')[0])
    .join(', ');

  const addFreeTextAsOption = () => {
    const trimmed = filterText.trim();
    if (!trimmed) return;

    const exists = selectedOptions.find((opt) => opt.value === trimmed);
    if (!exists) {
      const newOption = { id: trimmed, value: trimmed };
      const newValue = [...selectedOptions, newOption];
      setSelectedOptions(newValue);
      onChange?.(newValue);
    }
    setFilterText('');
  };

  useEffect(() => {
    if (!isFocused) return;
    const handler = (e) => {
      const target = e.target as HTMLDivElement;
      if (target.parentElement?.className === 'autocomplete-options-container') {
        return;
      }
      setIsFocused(false);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [isFocused]);

  return (
    <ContainerFlex row flex="0">
      <St.Container disabled={disabled} isFocused={isFocused}>
        {!!label && <label htmlFor={name}>{label}</label>}
        <ContainerFlex
          className="inputContainer"
          row
          space
          style={{ border: showChips ? '1px solid gray' : 'none' }}
        >
          {showChips && !!selectedOptions.length && (
            <div className="chips">
              {inputValue.split(',').map((e, i) => (
                <span key={i}>{e}</span>
              ))}
              {selectedOptions.length > limitTag &&
                `+${selectedOptions.length - limitTag}`}
            </div>
          )}

          <input
            id="auto-complete-input"
            ref={anchorRef}
            onClick={handleToggleFocus}
            placeholder="Digite e pressione Enter ou vírgula"
            name={name}
            type="text"
            onChange={(e) => setFilterText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ',') {
                e.preventDefault();
                addFreeTextAsOption();
              }
            }}
            onBlur={() => {
              if (filterText.trim()) {
                addFreeTextAsOption();
              }
            }}
            disabled={disabled}
            value={filterText}
            autoComplete="off"
          />


          {btnClear && (
            <Button
              size="small"
              fitContent
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setSelectedOptions([]);
                onChange?.([]);
              }}
            >
              Limpar
            </Button>
          )}
        </ContainerFlex>

        {errorMessage && <St.ErrorMessage>{errorMessage}</St.ErrorMessage>}
      </St.Container>
    </ContainerFlex>
  );
};

export default FreeSelectMultiple;
